import { injectTranslate } from '@recruitee/i18n';
import { usersAvatarsCellFactory } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const followersColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Followers,
  label: injectTranslate()('app.offers.table.followers'),
  visible: false,
  geometry: {
    width: 120,
    minWidth: 120,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: usersAvatarsCellFactory('followers'),
}));
